export const pricesHelper = (amount: number, allowCero?: boolean) => {
  if (amount || allowCero) {
    return amount.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: 'currency',
      currency: 'EUR',
    });
  }
};

export const percentageHelper = (
  previousValue: number,
  currentValue: number,
): number => {
  const diff = currentValue - previousValue;
  const diffPercentage = (diff / previousValue) * 100;
  return diffPercentage;
};

export const formatPrice = (number: number) => new Intl.NumberFormat('es-ES', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  style: 'currency',
  currency: 'EUR',
}).format(number);

export const formatPercentage = (amount: number, allowCero?: boolean) => {
  if (amount || allowCero) {
    return `${amount.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} %`;
  }
};

export const renderOpeningFee = (
  openingFee: number,
  openingFeeType: string,
): string => {
  if (openingFee > 0) {
    if (openingFeeType === 'F') {
      return `${pricesHelper(openingFee, true)} financiada`;
    }
    if (openingFeeType === 'P') {
      return `${pricesHelper(openingFee, true)} a abonar con la primera cuota`;
    }
    return `${pricesHelper(openingFee, true)}`;
  }
  return `${pricesHelper(openingFee, true)}`;
};
